import React from "react";

const ModuleOverviewRow = (props) => {
    const attributeName = props.attribute.module_catalog_key + " - " + props.attribute.name;
    const selectionValue = props.selection ? props.selection.toString() : "-";
    const attributeCount = selectionValue.replace(props.attribute.module_catalog_key, "");

    return <tr>
        <th>{attributeName}</th>
        <td>{attributeCount}</td>
    </tr>
}

export default ModuleOverviewRow;